'use es6';

import { Set as ImmutableSet, Map as ImmutableMap } from 'immutable';
import * as ChartTypes from 'reporting-data/constants/chartTypes';
const DO_NOT_SHOW_DEFAULT_NO_DATA = ImmutableSet([ChartTypes.DATA_WELL]);
export default ((report = ImmutableMap()) => {
  const chartType = report.get('chartType');
  return !DO_NOT_SHOW_DEFAULT_NO_DATA.contains(chartType);
});